import React from "react";
import "./report.css";

export default function DiffusionReport() {
  return (
    <div className="report-container">
      <h1>Diffusion Models with Non-Gaussian Noise</h1>

      <pre className="report-text">
        {`SUMMARY
• Proposed a mathematically optimized triangle-like noise distribution (bounded) to replace Gaussian in both forward and reverse diffusion, and analyzed its KL-optimal parameters, offering insight into why Gaussian often works while not being necessary. Achieved FID 28.073 (Triangle-Uniform) vs Gaussian baseline 28.908 under identical settings on CIFAR-10; a Triangle-Gaussian variant obtained 33.009.

METHOD & THEORY
• Defined a two-parameter triangle-like distribution Y with shape λ and scale θ; derived optimal parameters via KL minimization (closed-form aligns with numerical solution) and revealed an empirical/theoretical relation λ ≈ 1/θ that correlates with best FID regions.
• Kept DDPM architecture and reverse process intact, replacing the Gaussian density with f_Y and using the same variance schedule β_t; provided training and sampling algorithms accordingly.

EXPERIMENTS
• Dataset: CIFAR-10; compared pure Gaussian, Triangle-Gaussian, and Triangle-Uniform mixtures by decaying α from 1→0. Even at α=0 (pure triangle-like), generations remain visually strong and FID comparable or better than Gaussian. Best FID 28.073 (triangle-only).
• Training budget described (e.g., 30k–60k epochs under limited GPU), demonstrating that competitive results emerge without Gaussian assumptions.

IMPACT
• Shows that non-Gaussian bounded noise can match/exceed Gaussian performance in diffusion models, with a principled parameterization (λ, θ) guiding design and stability.`}
      </pre>
    </div>
  );
}
